






























































import { Component, Vue } from "vue-property-decorator";
import { set } from "vue/types/umd";
@Component({})
export default class PfWeChat extends Vue {
  private checked = false;
  private resInfo: any = {
    code: "",
    qrUrl: "",
  };
  private showWXwork: any = 1;
  private showqq: any = 1;
  private timer: any = null;
  private info: any = null;
  private openId: string = "";
  private WxLoginObj = null;
  private newLogin: any = "0";
  private to(type: any) {
    if (type == 1) {
      if (this.$subName == "longyixiu") {
        window.open("/help.html?articleId=15&articleType=3", "_blank");
      } else if (this.$subName == "wenjuanjia") {
        window.open("/help.html?articleId=704&articleType=3", "_blank");
      }
    } else {
      if (this.$subName == "longyixiu") {
        window.open("/help.html?articleId=14&articleType=3", "_blank");
      } else if (this.$subName == "wenjuanjia") {
        window.open("/help.html?articleId=705&articleType=3", "_blank");
      }
    }
  }
  private async getQRCode() {
    try {
      this.resInfo = await this.$apis.getQRCode();
    } catch (error) {
      console.log(error);
    }
  }
  private handleToEmit(componentName: any, userInfo: any = {}) {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
    this.$emit("goto", componentName, userInfo);
  }
  // created
  private created() {
    this.newLogin = this.$route.query.newLogin || "0";
    this.getQRCode();
    this.timer = setInterval(() => {
      this.getWxLoginStatus();
    }, 3000);
    document.title = "扫码登录_管理后台-" + this.$globalName;
    if (this.$route.query.newLogin == "1") {
      setTimeout(() => {
        this.initWxLogin();
      }, 1000);
    }
  }
  private initWxLogin() {
    // @ts-ignore
    this.WxLoginObj = new WxLogin({
      self_redirect: true,
      id: "login_container",
      appid: "wxcc9e9219d5502656",
      scope: "snsapi_login",
      redirect_uri: this.$tool.encrypt("https://www.longyixiu.com/login"),
      state: "",
      style: "",
      href: "",
      onReady: function (isReady: any) {
        console.log(isReady, "wxlogin isReady");
      },
    });
  }
  private handleToWxWork() {
    const agentCode: any =
      sessionStorage.getItem("LONGYIXIU_agentCode") || null;
    const taskId: any = sessionStorage.getItem("LoginTaskId") || null;
    const inviteCode: any = sessionStorage.getItem("LoginInviteCode") || null;
    console.log(taskId, inviteCode, "taskId");
    let appid = "wwb049ab06b49ac01a";
    if (this.$subName == "longyixiu") {
      appid = "wwb049ab06b49ac01a";
    } else if (this.$subName == "wenjuanjia") {
      appid = "ww8f1a67fc0e39b46a";
    }
    const owurl = `https://open.work.weixin.qq.com/wwopen/sso/3rd_qrConnect?appid=${appid}&usertype=member&redirect_uri=https://${
      window.location.host
    }/auth?${agentCode ? "&agentCode=" + agentCode : ""}${
      taskId ? "&taskId=" + taskId : ""
    }${inviteCode ? "&inviteCode=" + inviteCode : ""}&redirect=${
      this.$route.query.redirect || ""
    }`; // 获取微信扫描登录地址
    const str: any = this.$route.query.redirect;
    console.log(str, owurl);
    const tmp: any = window.open("about:blank", "", "fullscreen=1");
    tmp.moveTo(0, 0); // 指定窗口开始位置（左上角）
    tmp.resizeTo(1024, 720); // 指定窗口结束位置（右下角）
    tmp.focus();
    tmp.location = owurl;
    // } else if (this.$subName == "wenjuanjia") {
    //   //@ts-ignore
    //   const wwLogin = ww.createWWLoginPanel({
    //     el: "#ww_login",
    //     params: {
    //       login_type: "ServiceApp",
    //       appid: "ww4e9fc22cfaec9df2",
    //       redirect_uri: `https://${window.location.host}/auth?${
    //         agentCode ? "&agentCode=" + agentCode : ""
    //       }${taskId ? "&taskId=" + taskId : ""}${
    //         inviteCode ? "&inviteCode=" + inviteCode : ""
    //       }&redirect=${this.$route.query.redirect || ""}`,
    //       state: "loginState",
    //       redirect_type: "callback",
    //     },
    //     onCheckWeComLogin({ isWeComLogin }: { isWeComLogin: any }) {
    //       console.log(isWeComLogin);
    //     },
    //     onLoginSuccess({ code }: { code: any }) {
    //       console.log({ code });
    //     },
    //     onLoginFail(err: any) {
    //       console.log(err);
    //     },
    //   });
    // }
  }
  private handleToQQ() {
    // const str: any = this.$route.query.redirect;
    // console.log(str);
    const agentCode: any =
      sessionStorage.getItem("LONGYIXIU_agentCode") || null;
    const taskId: any = sessionStorage.getItem("LoginTaskId") || null;
    const inviteCode: any = sessionStorage.getItem("LoginInviteCode") || null;
    console.log(taskId, inviteCode, "taskId");
    let client_id = "102016843";
    if (this.$subName == "longyixiu") {
      client_id = "102016843";
    } else if (this.$subName == "wenjuanjia") {
      client_id = "102612587";
    }
    const owurl = `https://graph.qq.com/oauth2.0/authorize?response_type=code&client_id=${client_id}&state=1&redirect_uri=https://${
      window.location.host
    }/auth?${agentCode ? "&agentCode=" + agentCode : ""}${
      taskId ? "&taskId=" + taskId : ""
    }${inviteCode ? "&inviteCode=" + inviteCode : ""}&redirect=${
      this.$route.query.redirect || ""
    }`; // 获取微信扫描登录地址
    const tmp: any = window.open("about:blank", "", "fullscreen=1");
    tmp.moveTo(0, 0); // 指定窗口开始位置（左上角）
    tmp.resizeTo(1024, 720); // 指定窗口结束位置（右下角）
    tmp.focus();
    tmp.location = owurl;
  }
  // 轮询查看微信登录状态
  private async getWxLoginStatus() {
    // let vm = this;
    const params = {
      code: this.resInfo.code,
      agentCode: sessionStorage.getItem("LONGYIXIU_agentCode") || undefined,
      taskId: sessionStorage.getItem("LoginTaskId") || undefined,
      inviteCode: sessionStorage.getItem("LoginInviteCode") || undefined,
    };
    try {
      this.info = await this.$apis.getWxLoginStatus(params);
      if (this.info) {
        if (this.info.check) {
          clearInterval(this.timer);
          this.timer = null;

          if (this.info.username.startsWith("RR")) {
            // console.log("未绑定手机号");
            this.openId = this.info.openid;
            // console.log("openid", this.openId);
            this.handleToEmit("BindingLogin", this.info);
            return;
          } else {
            try {
              this.info.agentCode =
                sessionStorage.getItem("LONGYIXIU_agentCode") || null;
              await this.$store.dispatch("user/bindingInfo", this.info);
              const str: any = this.$route.query.redirect;
              if (str) {
                this.$router.replace(str);
              } else {
                this.$router.replace("/activeManagement.html");
              }
              // this.$router.push("/voting/list");
              this.$message.success("登录成功");
            } catch (error) {
              console.log(error);
            }
          }
        }
      }
    } catch (error) {
      // console.log("error", error);
      clearInterval(this.timer);
      this.timer = null;
    }
  }
}
